/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceTeamWithDetails } from './ServiceTeamWithDetails';
import {
	ServiceTeamWithDetailsFromJSON,
	ServiceTeamWithDetailsFromJSONTyped,
	ServiceTeamWithDetailsToJSON,
} from './ServiceTeamWithDetails';

/**
 * Payload of enumerated service teams from search with pagination support
 * @export
 * @interface SearchServiceTeamsResponse
 */
export interface SearchServiceTeamsResponse {
	/**
	 *
	 * @type {Array<ServiceTeamWithDetails>}
	 * @memberof SearchServiceTeamsResponse
	 */
	items: Array<ServiceTeamWithDetails>;
	/**
	 * Continuation token for pagination to be used in subsequent search requests
	 * @type {string}
	 * @memberof SearchServiceTeamsResponse
	 */
	continuationToken?: string;
}

/**
 * Check if a given object implements the SearchServiceTeamsResponse interface.
 */
export function instanceOfSearchServiceTeamsResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'items' in value;

	return isInstance;
}

export function SearchServiceTeamsResponseFromJSON(
	json: any
): SearchServiceTeamsResponse {
	return SearchServiceTeamsResponseFromJSONTyped(json, false);
}

export function SearchServiceTeamsResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SearchServiceTeamsResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		items: (json['items'] as Array<any>).map(ServiceTeamWithDetailsFromJSON),
		continuationToken: !exists(json, 'continuationToken')
			? undefined
			: json['continuationToken'],
	};
}

export function SearchServiceTeamsResponseToJSON(
	value?: SearchServiceTeamsResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		items: (value.items as Array<any>).map(ServiceTeamWithDetailsToJSON),
		continuationToken: value.continuationToken,
	};
}
